/**
 * Returns the number of contiguous groups that fit before the secondary menu.
 * Groups are intentionally considered in order so the rightmost groups are
 * the first ones to move into Mais as the available width decreases.
 */
export const estimateVisibleGroupCount = (
  availableWidth: number,
  groupWidths: number[],
  moreWidth: number,
) => {
  const safeAvailableWidth = Math.max(0, availableWidth);
  const safeMoreWidth = Math.max(0, moreWidth);
  let consumedWidth = safeMoreWidth;
  let visibleCount = 0;

  for (const groupWidth of groupWidths) {
    const safeGroupWidth = Math.max(0, groupWidth);
    if (consumedWidth + safeGroupWidth > safeAvailableWidth) break;
    consumedWidth += safeGroupWidth;
    visibleCount += 1;
  }

  return visibleCount;
};
